import React from 'react'
// import sdff from "../"

const HeadServiceForm = () => {
  return (
    <div
    className='service-head-tile'
    style={{
        backgroundImage: "url(" + require("../assets/img/vacspl/plant.jpeg") + ")",
      }}
    >
           <h2>Inspection From VACSPL</h2>
           <p>Your Plant needs the care so that it can provide maximum efficiency</p>
    </div>
  )
}

export default HeadServiceForm